import { RuleTypeEnum } from '@monetize/types/app';
import {
  SETTINGS_QUOTE_SHARE,
  SETTINGS_QUOTE_SHARE_RULE_CREATE,
  getQuoteShareRuleEditRoute,
  getRuleCreateRoute,
  getRuleEditRoute,
  getRuleListRoute,
} from '../../../constants/routes';

type RouteParamType = Parameters<typeof getRuleListRoute>[0];

export const getRuleRouteType = (type: RuleTypeEnum): RouteParamType => {
  switch (type) {
    case RuleTypeEnum.APPROVAL:
      return 'approvals';
    case RuleTypeEnum.CONDITIONAL_TERM:
      return 'conditional-terms';
    case RuleTypeEnum.VALIDATION:
      return 'validations';
    case RuleTypeEnum.RECORD_AUTOMATION:
      return 'record-automation';
    default:
      throw new Error(`Invalid rule type: ${type}`);
  }
};

export interface RuleRouteSet {
  list: string;
  create: string;
  getEdit: (ruleId: string) => string;
}

export const getRuleRouteSet = (type: RuleTypeEnum): RuleRouteSet => {
  const routeType = getRuleRouteType(type);
  return {
    list: getRuleListRoute(routeType),
    create: getRuleCreateRoute(routeType),
    getEdit: (ruleId) => getRuleEditRoute(ruleId, routeType),
  };
};

export const QUOTE_SHARE_RULE_ROUTES: RuleRouteSet = {
  list: SETTINGS_QUOTE_SHARE,
  create: SETTINGS_QUOTE_SHARE_RULE_CREATE,
  getEdit: getQuoteShareRuleEditRoute,
};
